
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import UserService from '@/services/user.service';
import { ISPUImageUploadOptions } from '@/common/interface/spu';
import { BASE_URL } from '@/common/constant';
import { $delay } from '@/common/utils';
import { component as Viewer } from 'v-viewer';
import lazyInject from '@/di';
import { FormModel } from 'ant-design-vue';
import moment, { Moment } from 'moment';
import VoucherService from '@/services/voucher.service';

@Component({
  components: {
    Viewer,
  },
})
export default class AddVoucherModal extends Vue {
  visible = false;

  uploading = false;

  type = '';

  rules: any = {
    headlineImage: [
      { required: true, message: '请上传支付凭证', trigger: 'change' },
    ],
    channel: [
      { required: true, message: '请选择支付渠道', trigger: 'change' },
    ],
    amount: [
      { required: true, message: '请输入收款凭证金额', trigger: 'change' },
    ],
    payee: [
      { required: true, message: '请输入付款方', trigger: 'change' },
    ],
    flowNo: [
      { required: true, message: '请输入收款流水号', trigger: 'change' },
    ],
    receivePaymentTime: [
      { required: true, message: '请输入收款时间', trigger: 'change' },
      { validator: this.validateTimeNotInFuture, trigger: 'change' },
    ],
  };

  fileList: any = [];

  BASE_URL = BASE_URL;

  labelCol = {
    span: 6,
  };

  wrapperCol = {
    span: 12,
  };

  form: any = {
    flowNo: '',
    channel: '',
    resourceId: '',
    headlineImage: '',
    receivePaymentTime: '',
    amount: '',
    payee: '',
  };

  token: string | undefined = undefined;

  options: ISPUImageUploadOptions = {
    allowDuplicateUploads: false,
    target: `${BASE_URL}/tool/upload`,
    testChunks: false,
    headers: {},
    chunkSize: 5 * 1024 * 1024,
  };

  @lazyInject(UserService)
  protected userService!: UserService;


  @lazyInject(VoucherService)
  voucherService!: VoucherService;

  @Ref('ruleForm')
  private ruleForm!: FormModel;

  @Prop()
  paymentChannel?: any;

  validateTimeNotInFuture(rule: any, value: any) {
    if (!value) {
      // 如果值为空，由 required 规则处理
      return Promise.resolve();
    }

    // 将 value 转为 Date 对象（注意：value 是字符串，格式为 YYYY-MM-DD HH:mm:ss）
    const selectedTime = new Date(value);
    const now = new Date();

    if (selectedTime > now) {
      return Promise.reject('时间必须小于当前时间');
    }

    return Promise.resolve();
  }

  handleOk() {
    console.log(this.form);
    this.ruleForm.validate(async (valid) => {
      if (valid) {
        const data = {
          flowNo: this.form.flowNo,
          channel: this.form.channel,
          resourceId: this.fileList[0].id || '',
          receivePaymentTime: moment(this.form.receivePaymentTime).format('YYYY-MM-DD HH:mm:ss'),
          amount: this.form.amount,
          payee: this.form.payee,
          labelId: 1,
        };
        console.log(data);
        const res = await this.voucherService.postDyhOrderVoucherAddReceiptVoucher(data);
        if (res) {
          this.$message.success('添加成功');
          this.$emit('queryChange', this.form.flowNo);
          this.ruleForm.resetFields();
          this.fileList = [];
          this.$emit('search');
          this.visible = false;
        }
      } else {
        return false;
      }
    });
  }

  handleCancel() {
    this.visible = false;
    this.ruleForm.resetFields();
    this.fileList = [];
  }

  init(type: string) {
    this.type = type;
    this.form.receivePaymentTime = moment(new Date());
    this.visible = true;
  }

  created() {
    this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }

  onChangePaymentTime(value: Moment) {
    this.$set(this.form, 'receivePaymentTime', value);
  }

  beforeUpload(file: { type: string; size: number }) {
    this.aginGetToken();
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error('请上传 png/jpeg 格式的照片!');
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      this.$message.error('照片必须小于5MB!');
    }

    return isJpgOrPng && isLt5M;
  }
  aginGetToken() {
    this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }
  _v = 1;
  async onRemove(v: any) {
    // console.log(v);
    this._v = v;
  }

  delShopImg(index: number) {
    // if (this.fileList.length < 4) {
    //   this.$message.error('店铺相册图片不能小于3张');
    // } else {
    const idList = this.fileList.map((item: any) => item.id);
    idList.splice(index, 1);
    this.fileList.splice(index, 1);
    // }
  }

  async onChangeImg(info: any) {
    // console.log(info);
    if (info.file.status === 'uploading') {
      this.uploading = true;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response;
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      const headlineImage = {
        id: data[0]?.id,
        uid: data[0]?.id,
        url: data[0]?.url,
        name: 'mage.png',
        status: 'done',
      };
      this.fileList.push(headlineImage);
      this.$set(this.form, 'headlineImage', headlineImage);
      this.uploading = false;
    }
    if (info.file.status === 'removed') {
      if (info.file.xhr) {
        const { data } = JSON.parse(info.file.xhr.response);
        const id = data[0]?.id;
        this.fileList = this.fileList.filter((res: { id: any }) => { return res.id !== id; });
      } else {
        // console.log(info.file);
        const { id } = info.file;
        this.fileList = this.fileList.filter((res: { id: any }) => { return res.id !== id; });
      }
    }
  }
}
